import {makeStyles} from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  item: {
    marginBottom: 20,
    color: theme.palette.secondary.dark,
  },
  amount: {
    display: 'block',
  },
  amountCurrency: {
    fontSize: 34,
    fontWeight: 300,
    padding: '0 3px',
  },
  amountValue: {
    fontSize: 34,
    fontWeight: 300,
  },
  amountFraction: {
    fontSize: 34,
    fontWeight: 300,
  },
}))
